export default {
    "uberId": "u.C2761EB6-D53B-66BB-5798-9A8181AEAD02",
    "genderType": {"typeId": 398, "typeCd": "FEM", "typeName": "Female"},
    "financialExperienceLevelType": {"typeId": 401, "typeCd": "Intermediate", "typeName": "INT "},
    "investmentsGoals": [{
        "clientProfileInvestmentGoals": {
            "typeId": 392, "typeCd": "Retirement Planning", "typeName": "RET "
        }, "origUserId": "RWS", "origTimeStamp": "", "lastUpdatedUserId": "RWS", "lastUpdatedTimeStamp": ""
    }],
    "attributes": [],
    "effectiveTimestamp": "",
    "expirationTimestamp": "",
    "origUserId": "RWS",
    "origTimeStamp": "",
    "lastUpdatedUserId": "RWS",
    "lastUpdatedTimeStamp": ""
}
